import { useState } from 'react';
import styled from 'styled-components';
import { Card, List, Row, Space, Typography } from 'antd';
import { Collapse } from 'antd-mobile';
import PageMobile from '../../../components/page-mobile';
import useTranslations from '../../../hooks/useTranslations';
import DynamicIcon from '../../../components/dynamic-icon';
import AboutUsContextProvider from './context/AboutUsContextProvider';
import { useAboutUsCtx } from './context/AboutUsContext';
import Segmented from '../../../components/segmented';

const { Text } = Typography;

const iconNameMap = ['clockuser', 'handshake', 'privacy', 'like'];

const CardStyled = styled(Card)`
    .ant-card-body {
        padding: 12px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        align-items: center;
    }
`;

function About() {
    const { t } = useTranslations();
    const { about, isLoading, isLoadingCustomerPlatformInfo, customerPlatformInfo } = useAboutUsCtx();

    const textAboutUs = t('AboutUs', 'About Us');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
            <CardStyled loading={isLoading}>
                <div style={{ marginBottom: 4 }}>
                    <Text strong>{textAboutUs}</Text>
                </div>
                <div style={{ display: 'flex' }}>
                    <Text style={{ color: '#OE3D39', textAlign: 'center' }}>{about}</Text>
                </div>
            </CardStyled>
            <CardStyled loading={isLoadingCustomerPlatformInfo}>
                <List
                    dataSource={customerPlatformInfo}
                    renderItem={(item, index) => (
                        <List.Item>
                            <Row
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: 12,
                                    width: '100%',
                                    alignItems: 'center',
                                }}
                            >
                                <DynamicIcon iconName={iconNameMap[index]} />
                                <Text strong>{item?.title}</Text>
                                <Text type="secondary" style={{ textAlign: 'center' }}>
                                    {item?.description || '-'}
                                </Text>
                            </Row>
                        </List.Item>
                    )}
                />
            </CardStyled>
        </div>
    );
}

function Regulations() {
    const { platformRegulations } = useAboutUsCtx();

    return (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
            {platformRegulations.map((item, index) => (
                <Collapse defaultActiveKey={['1']} key={index}>
                    <Collapse.Panel key="1" title={item?.title}>
                        <Text>{item?.description}</Text>
                    </Collapse.Panel>
                </Collapse>
            ))}
        </Space>
    );
}

function AboutUs() {
    const [activeTab, setActiveTab] = useState('about');
    const { t } = useTranslations();

    const textAbout = t('About', 'About');
    const textRegulations = t('Regulations', 'Regulations');
    return (
        <PageMobile>
            <Segmented
                options={[
                    { label: textAbout, value: 'about' },
                    { label: textRegulations, value: 'regulations' },
                ]}
                onChange={(value) => setActiveTab(value)}
            />
            {activeTab === 'about' && <About />}
            {activeTab === 'regulations' && <Regulations />}
        </PageMobile>
    );
}

function _AboutUs() {
    return (
        <AboutUsContextProvider>
            <AboutUs />
        </AboutUsContextProvider>
    );
}
export default _AboutUs;
